import { render, staticRenderFns } from "./ZnsHistory.vue?vue&type=template&id=74325888"
import script from "./ZnsHistory.vue?vue&type=script&lang=js"
export * from "./ZnsHistory.vue?vue&type=script&lang=js"
import style0 from "./ZnsHistory.vue?vue&type=style&index=0&id=74325888&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports